<template>
  <div class="container">
    <div class="collage-photo__group-title">
      <h6 class="font-weight-medium">{{ $t('pages.checkins_detail.all_photos') }}</h6>
    </div>
    <view-loader :padding-classes="'py-6'" v-if="photos.length === 0 "/>
    <div class="position-relative" :class="{'collage-photo--clipped': showBlender}" v-else>
      <all-photos-list :checkin="checkin"
                       :photos="photos"
                       @paginate="load"
                       :page="page"
                       :total-photos="count"/>

      <div style="height: 36px" class="text-center mt-2">
        <div v-show="paginate">
          <view-loader :padding-classes="'py-2'" v-if="loading"/>
          <b-button @click="load()" variant="primary" size="sm" v-else>
            {{ $t('pages.checkins_detail.load_more') }}
            <Icon name="plus" width="16" vertical-align="sub"/>
          </b-button>
        </div>
      </div>
      <transition name="fade">
        <div class="collage-photo__blender" v-if="showBlender">
          <b-button @click="show()" variant="primary" size="sm" v-show="showBlender">
            {{ $t('pages.checkins_detail.show_all_photos') }} <Icon name="plus" width="16" vertical-align="sub" />
          </b-button>
        </div>
      </transition>
    </div>

  </div>
</template>


<script>
import ViewLoader from "@/components/ViewLoader.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import AllPhotosList from "@/domain/media/allPhotos/AllPhotosList.vue";

export default {
  name: 'AllPhotos',
  components: {
    AllPhotosList,
    ViewLoader,
  },
  data() {
    return {
      loading: false,
      loadingSection: true,
      showBlender: true,
      observer: null,
    }
  },

  props: {
    checkin: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('mediaAllPhotos', ['photos', 'paginate', 'count', 'page']),
  },
  mounted() {
    this.resetPagination()
    this.load()
  },
  methods: {
    ...mapActions('mediaAllPhotos', ['fetchPhotos']),
    ...mapMutations('mediaAllPhotos', ['resetPagination']),
    async show() {
      this.showBlender = false
      //await this.load()
    },
    async load() {
      if (this.loading || !this.paginate) return
      this.loading = true

      await this.fetchPhotos({
        pica_service: this.checkin.pica_service.id
      })

      this.loading = false
      this.loadingSection = false
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
</script>

